import NonePng from '../../assets/png/profile.png'

interface Props {
    url?: string;
    width?: string;
}

const Avatar = ({url, width = 'width-30'}: Props) => {
    return (
        <div
            className={`${width} aspect-ratio-1 display-flex align-items-center justify-content-center rounded-circle`}
            style={{
                backgroundImage: `url(${url || NonePng})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                minWidth: 30,
                minHeight: 30,
            }}
        />
    )
}

export default Avatar;